import type { CircleButtonProps } from './CircleButton';
import type { Ref } from 'react';

import { forwardRef } from 'react';
import { styled } from 'styled-components';

import { secondaryButtonColorsAqua, secondaryButtonColorsBlue, secondaryButtonColorsGreen } from '../SecondaryButton';

import { DefaultCircleButtonSC } from './CircleButton';

type SecondaryCircleButtonProps = CircleButtonProps & {
  colorVariant?: 'blue' | 'green' | 'aqua';
};

const SecondaryCircleButtonSC = styled(DefaultCircleButtonSC)<{ $colorVariant?: 'blue' | 'green' | 'aqua' }>`
  ${(props) => {
    switch (props.$colorVariant) {
      case 'blue':
        return secondaryButtonColorsBlue;
      case 'aqua':
        return secondaryButtonColorsAqua;
      default:
        return secondaryButtonColorsGreen;
    }
  }}

  border: 0.125rem solid;
`;

export const SecondaryCircleButton = forwardRef(
  ({ colorVariant, icon, size, ...props }: SecondaryCircleButtonProps, ref: Ref<HTMLButtonElement>) => {
    return (
      <SecondaryCircleButtonSC ref={ref} $colorVariant={colorVariant} $size={size} {...props}>
        {icon}
      </SecondaryCircleButtonSC>
    );
  },
);
